module.exports = __webpack_public_path__ + "static/dwarf_paladin_female_SCAG-71a66fe87e2af813f0bf9ac6c393c2ac.png";